// HomeBgBanner.jsx

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { URL } from "../Redux/common/url";

function HomeBgBanner() {
  // slider_list se ads nikal rahe hain
  const slider_list = useSelector((state) =>
    state?.allapi?.slider_list ? state.allapi.slider_list : {}
  );

  const ad = slider_list?.ads ? slider_list.ads : [];

  const [activeAd, setActiveAd] = useState(0);

  useEffect(() => {
    // agar ads hi nahi aaye to interval mat chalao
    if (!ad.length) return;

    const rotate = setInterval(() => {
      setActiveAd((prev) => (prev + 1) % ad.length);
    }, 3000);

    return () => clearInterval(rotate);
  }, [ad.length]);

  // data na ho to kuch bhi render mat karo
  if (!ad.length) return null;

  const activeImage = URL?.API_BASE_URL + ad[activeAd]?.image;

  return (
    <div className="homebgbanner">
      <div className="ads-slider-wrapper d-flex justify-content-center align-items-center px-0 mb-4 mt-3">
        <div
          className="ads-slider-box"
          style={{
            backgroundImage: `url(${activeImage})`,
          }}
        ></div>
      </div>
    </div>
  );
}

export default HomeBgBanner;
